// Feature flags for gradual rollout
// Note: import.meta.env may be undefined when using bun build directly
const env = typeof import.meta !== 'undefined' ? import.meta.env : undefined;

export const config = {
  // API Configuration
  apiUrl: env?.VITE_API_URL || 'https://api.gameindustry.be',
  useApi: env?.VITE_USE_API === 'true',
  enableFallback: env?.VITE_ENABLE_FALLBACK !== 'false', // Default true

  // Other config
  environment: env?.MODE || 'production',
  isDevelopment: env?.DEV || false,
  isProduction: env?.PROD ?? true, // Default to production if undefined
} as const;

export type Config = typeof config;
